export default "__VITE_ASSET__X$KBX0A7__"